import {
  isPassportPublicAnalyticsPath,
  PASSPORT_PUBLIC_GA_MEASUREMENT_ID
} from '../constants/passportPublicAnalytics';

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

/** SPA route changes on public pages (initial page_view comes from index.html gtag). */
export function trackPassportPublicPageView(pathname: string): void {
  if (typeof window.gtag !== 'function') return;
  if (!isPassportPublicAnalyticsPath(pathname)) return;

  const pagePath = pathname.replace(/\/+$/, '') || '/';
  window.gtag('config', PASSPORT_PUBLIC_GA_MEASUREMENT_ID, { page_path: pagePath });
}
